module.exports = __webpack_public_path__ + "img/cuadrado.837654fa.png";